module.exports = __webpack_public_path__ + "img/Gen3-Indoor.7b31fb81.svg";